exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "#notFound{padding:10em;color:#fff}", "", {"version":3,"sources":["D:/laragon/www/sima/simaapp-web/src/components/404.vue"],"names":[],"mappings":"AACA,UACE,aAAc,AACd,UAAa,CACd","file":"404.vue","sourcesContent":["\n#notFound {\r\n  padding: 10em;\r\n  color: white;\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4785c218","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/404.vue
// module id = 409
// module chunks = 6